import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { connect } from 'react-redux'
import { getLanguage } from '../store/actions/languageActions'

const ContactSystemAdmin = ({ type, onGetLanguage, langDetails }) => {
  const langText = langDetails?.constantStrings
  const [error, setError] = useState(null)
  useEffect(() => {
    onGetLanguage(localStorage.getItem('language'))
  }, [JSON.stringify(localStorage.getItem('language'))])

  useEffect(() => {
    if (type === 'ErrorRSTUSR') {
      setError(langText?.errorRSTUSR)
    } else if (type === 'ErrorSRVDWN') {
      setError(langText?.errorSRVDWN)
    } else if (type === 'ErrorMLTUSR') {
      setError(langText?.errorMLTUSR)
    } else if (type === 'ErrorUSNTFD') {
      setError(langText?.errorUSNTFD)
    } else if (type === 'ErrorINACTV') {
      setError(langText?.errorINACTV)
    } else if (type === 'ErrorDUPLNK') {
      setError(langText?.errorDUPLNK)
    } else {
      setError(langText?.server_error)
    }
  }, [langText, type])

  return (
        <Grid item container xs={12} lg={12} md={12}>
          <p className='contact-system-admin-txt'>{error}</p>
        </Grid>
  )
}

const mapStateToProps = (state) => ({ langDetails: state.language })

const mapDispatchToProps = (dispatch) => {
  return {
    onGetLanguage: (lang) => dispatch(getLanguage(lang))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactSystemAdmin)
